export default {
  logoAriaLabel: "Wells Fargo",
  skipLabel: "Skip to content"
};